import { render } from "./OldLiveData.vue?vue&type=template&id=951c2be8&scoped=true&ts=true"
import script from "./OldLiveData.vue?vue&type=script&lang=ts"
export * from "./OldLiveData.vue?vue&type=script&lang=ts"

import "./OldLiveData.vue?vue&type=style&index=0&id=951c2be8&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-951c2be8"]])

export default __exports__